export type BlockGroup = { type: "quiz" | "content"; blocks: ContentBlock[] };

/**
 * Groups consecutive non-quiz blocks together, while keeping each quiz block
 * in its own group. This allows rendering consecutive content blocks as a
 * single unit (e.g. inside one `<ClientContentBlocks>`) instead of one-by-one.
 */
export function groupConsecutiveNonQuizBlocks(
  blocks: ContentBlock[],
): BlockGroup[] {
  const groups: BlockGroup[] = [];

  for (const block of blocks) {
    if (block.type === "quiz") {
      groups.push({ type: "quiz", blocks: [block] });
    } else {
      // Check if the last group is a content group
      const lastGroup = groups[groups.length - 1];
      if (lastGroup && lastGroup.type === "content") {
        // Add to existing content group
        lastGroup.blocks.push(block);
      } else {
        // Create new content group
        groups.push({ type: "content", blocks: [block] });
      }
    }
  }

  return groups;
}
